import classNames from 'classnames';
import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { Button } from './Button';

export type PrimaryButtonProps = PropsWithChildren<{
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  disabled?: boolean;
  /** Black and outlined unless told otherwise; a page's main action (Validate) is filled in the brand colour. */
  variant?: 'outlined' | 'contained';
  color?: 'black' | 'primary';
}>;

export function PrimaryButton({
  className,
  onClick,
  children,
  disabled,
  variant = 'outlined',
  color = 'black',
}: PrimaryButtonProps) {
  return (
    <Button
      className={classNames('text-base', className)}
      variant={variant}
      size="small"
      color={color}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
